import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=485380de&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=485380de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485380de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('485380de')) {
      api.createRecord('485380de', component.options)
    } else {
      api.reload('485380de', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=485380de&scoped=true&", function () {
      api.rerender('485380de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22A76H66ogMlr/JS/comp/PopupBox.vue"
export default component.exports